export const WALLET_VERSION = '0.3'
export const DARA_RESTRICTION = 5000
